import React from 'react';

class SortButton extends React.Component {

  render() {
    return (
      <button className={ `brews-sort__button ${ this.props.sort === this.props.type && 'is-active' }`} onClick={ this.props.onClick }>
        <span>{ this.props.label }</span>
        <i className="material-icons">arrow_drop_down</i>
      </button>
    )
  }
}

export default SortButton;
